<template>

</template>

<script>
    export default {
        name: "individual-lesson"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/supu/individualLesson.vue